var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiStarsIcon = function SvgAiStarsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aiStarsIcon_svg__a)",
    d: "M14.632 9.986a.542.542 0 0 1 0 1.028l-2.906.968a4.34 4.34 0 0 0-2.742 2.743l-.967 2.904a.542.542 0 0 1-1.03 0l-.967-2.905a4.34 4.34 0 0 0-2.743-2.742l-2.904-.967a.542.542 0 0 1 0-1.03l2.905-.967A4.34 4.34 0 0 0 6.02 6.277l.968-2.906a.542.542 0 0 1 1.029 0l.967 2.906a4.34 4.34 0 0 0 2.742 2.741zm7.648-5.794a.326.326 0 0 1 0 .618l-1.743.58a2.6 2.6 0 0 0-1.645 1.645l-.58 1.743a.325.325 0 0 1-.619 0l-.58-1.743a2.6 2.6 0 0 0-1.646-1.645l-1.743-.58a.325.325 0 0 1 0-.618l1.743-.58a2.6 2.6 0 0 0 1.646-1.646l.58-1.743a.326.326 0 0 1 .618 0l.58 1.743a2.6 2.6 0 0 0 1.646 1.645zm1.574 10.602a.217.217 0 0 1 .106.332.2.2 0 0 1-.106.079l-1.161.387a1.73 1.73 0 0 0-1.098 1.098l-.387 1.16a.217.217 0 0 1-.411 0l-.387-1.16a1.74 1.74 0 0 0-1.098-1.098l-1.161-.387a.217.217 0 0 1 0-.41l1.16-.388a1.74 1.74 0 0 0 1.099-1.098l.387-1.16a.218.218 0 0 1 .41 0l.388 1.162c.172.519.579.925 1.098 1.098z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aiStarsIcon_svg__a",
    x1: 22.918,
    x2: 1.015,
    y1: 2.287,
    y2: 28.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BBFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7F6AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#B651D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E83E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8939"
  })))));
};
export default SvgAiStarsIcon;